export const selectBordCreate = ({ boards: { create } }) => create;
export const selectBordEdit = ({ boards: { edit } }) => edit;
export const selectMainBoards = ({ boards: { get } }) => get;
export const selectDeletedBoard = ({ boards: { deleteBoard } }) => deleteBoard;
export const selectGetByIdBoard = ({ boards: { getById } }) => getById;

export const selectSelectableBoards = ({ boards: { selectableBoards } }) => selectableBoards;
export const selectStatistic = ({ boards: { getStatistic } }) => getStatistic;
